import { Component, OnInit, Input } from '@angular/core';

import { UserConfigPanelService } from '../../services/user-config-panel.service';
@Component({
  selector: 'app-config-line',
  templateUrl: './config-line.component.html',
  styleUrls: ['./config-line.component.scss']
})
export class ConfigLineComponent implements OnInit {

  @Input() withAll : boolean = false;
  @Input() withHr : boolean = true;
  @Input() title : string = ""
  @Input() subTitle : string = ""
  @Input() description : string = ""
  @Input() titleLevel : number = 10 // titulo normal

  // filtro opcional
  @Input() render : boolean = true;
  @Input() disabled : boolean = false;
  @Input() filterBy? : string;

  @Input() sectionReturn? : string;

  constructor(
    public userConfigPanel : UserConfigPanelService
  ) { }

  ngOnInit(): void {
  }

  get matchesFilter(): boolean {
    if (!this.filterBy || this.filterBy.trim() === '') {
      return true; // si no hay filtro, siempre se muestra
    }

    const filter = this.filterBy.toLowerCase();
    return (
      this.title.toLowerCase().includes(filter) ||
      this.description.toLowerCase().includes(filter)
    );
  }


  public onBackClick() {
    if(this.sectionReturn){
      console.log(this.sectionReturn, "seccion para regresar")
      this.userConfigPanel.setSelectedSection(this.sectionReturn)
    }
  }

}
